// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2vRHt","question":"Question_question__3Gj0n","description":"Question_description__1EY0L"};